<div>
  <mat-tab-group style="width: 100%; background: white;padding-bottom: 60px;" (selectedTabChange)="sendBroadcast($event)">
      <mat-tab label="{{'CERTIFICAR.REACTIVOS.TABS.TAB1' | translate}}">
        <native></native>
      </mat-tab>

      <mat-tab label="{{'CERTIFICAR.REACTIVOS.TABS.TAB2' | translate}}">
        <traduccionreactivos></traduccionreactivos>
      </mat-tab>

      <mat-tab label="{{'CERTIFICAR.REACTIVOS.TABS.TAB3' | translate}}">
        <reactivospreview></reactivospreview>
      </mat-tab>
  </mat-tab-group>


    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
      <button *ngIf="!pasoCompleto && !cargando" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
        matTooltip="{{'CERTIFICAR.REACTIVOS.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20"
        (click)="completarPaso()"
      >
        <mat-icon>done</mat-icon>
      </button>
      <button *ngIf="pasoCompleto && !cargando"  mat-raised-button class="done mr-20">
        {{'CERTIFICAR.REACTIVOS.STATUS.DONE' | translate}}
        <mat-icon class="ml-20">done</mat-icon>
      </button>
    </div>
</div>
